export const trackingEvents = {
  DOWNLOAD_CSV_BUTTON: {
    CLICKED: 'employer_networks.download_csv_btn.clicked',
  },
}
